import React, { Component } from 'react';


class NavBar extends Component {

  constructor(props) {
    super(props);
    this.state = {
      permissions: {},
      username: localStorage.getItem("username"),
    }
  }

  componentDidMount = () => {
    this.getPermissions();
  }

  getPermissions = () => {
    fetch(
      "/api/getPermissions",
      {
        method: "GET",
        credentials: "same-origin",
      },
    )
    .then(res => {
      if (!res.ok) {
        throw Error(res.statusText);
      } else {
        return res.json();
      }
    })
    .then(data => this.setState({permissions: data}))
    .catch(error => console.log(error));
  }

  renderOptions = () => {
    let currentView = this.props.view;

    let userManagementButton;
    if(this.state.permissions.userManagement) userManagementButton = <a className = "dropdown-item" id ={currentView === "userManagement" ? "selected" : ""}  onClick={() => this.props.changeView("userManagement") }>User Management</a>

    let createUserButton;
    if(this.state.permissions.createUser) createUserButton = <a className="dropdown-item" id ={currentView === "userCreate" ? "selected" : ""}  onClick={() => this.props.changeView("userCreate") }>Create User</a>

    let sitesButton = <a className="dropdown-item" id ={currentView === "sites" || currentView === "null" ? "selected" : ""}  onClick={() => this.props.changeView("sites") }>Sites</a>

    let updateInfoButton = <a className="dropdown-item" id ={currentView === "updateInfo" ? "selected" : ""}  onClick={() => this.props.changeView("updateInfo") }>Update Details</a>

    let siteManagementButton;
    if (this.state.permissions.siteManagement) siteManagementButton = <a className="dropdown-item" id ={currentView === "siteManagement" ? "selected" : ""}  onClick={() => this.props.changeView("siteManagement") }>Site Management</a>

    let logsButton;
    if (this.state.permissions.logs) logsButton = <a className="dropdown-item" id ={currentView === "logs" ? "selected" : ""}  onClick={() => this.props.changeView("logs") }>View Logs</a>

    let logoutButton = <a className="dropdown-item" onClick={() => this.props.logout() }>Logout</a>

    return (
      <div>
        {sitesButton}
        {userManagementButton}
        {createUserButton}
        {siteManagementButton}
        {updateInfoButton}
        {logsButton}
        {logoutButton}
      </div>
    );
  }

  render() {
    return (
      <nav className="navbar navbar-expand-sm navbar-dark bg-dark static-top">
        <div className="container">

          <button className="navbar-brand" onClick={() => this.props.changeView("sites") }><img alt="DCNet_Logo" height="100%" src="https://s3-ap-southeast-2.amazonaws.com/dcnetres/dcNet.png"></img></button>

          <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarResponsive">
            <ul className="navbar-nav mx-auto navbar-right">
              <li className="nav-item dropdown">
                <a className="nav-link dropdown-toggle btn" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false"><span className="glyphicon glyphicon-user"></span>{` ${this.state.username}`}</a>
                <div className="dropdown-menu">
                  {this.renderOptions()}
                </div>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    );
  }
}

export default NavBar;


// WEBPACK FOOTER //
// ./src/Components/nav/NavBar.js